import { Co2MaterialLibrary, Co2MaterialLibraryScope, MaterialLibraryType } from "@api/apiClient";

export const isApplicationMaterialLibrary = (library: Co2MaterialLibrary): boolean =>
  !library.scope || library.scope === Co2MaterialLibraryScope.Application;

export const isProjectMaterialLibraryForParent = (library: Co2MaterialLibrary, parentId?: string): boolean =>
  library.scope === Co2MaterialLibraryScope.Project && !!parentId && library.parentId === parentId;

export const isMaterialLibraryInScope = (
  library: Co2MaterialLibrary,
  scope: Co2MaterialLibraryScope | undefined,
  parentId?: string,
): boolean => {
  if (library.materialLibraryType !== MaterialLibraryType.PrimarySQL) {
    return false;
  }

  const effectiveScope = scope ?? Co2MaterialLibraryScope.Application;

  if (effectiveScope === Co2MaterialLibraryScope.Project) {
    return isApplicationMaterialLibrary(library) || isProjectMaterialLibraryForParent(library, parentId);
  }

  return isApplicationMaterialLibrary(library);
};

export const getScopedMaterialLibraries = (
  libraries: Co2MaterialLibrary[] | undefined,
  projectId?: string,
): Co2MaterialLibrary[] => {
  if (!libraries?.length) {
    return [];
  }

  const scope = projectId ? Co2MaterialLibraryScope.Project : Co2MaterialLibraryScope.Application;
  return libraries.filter((library) => isMaterialLibraryInScope(library, scope, projectId));
};
